// src/redux/slices/questionSlice.ts

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchQuestionsAPI, fetchQuestionsByTagsAPI, fetchQuestionsSetAPI } from "@/services/api/Question";

export const fetchQuestions = createAsyncThunk(
  "questions/fetchQuestions",
  async (
    {
      pageNo = 1,
      perPage = 10,
      search = "",
    }: { pageNo?: number; perPage?: number; search?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetchQuestionsAPI(pageNo, perPage, search);
      return {
        results: response?.data?.results || [],
        totalRecord: response?.data?.totalRecord || 0,
      };
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "Error fetching questions"
      );
    }
  }
);

export const fetchQuestionsSet = createAsyncThunk(
  "questions/fetchQuestionsSet",
  async (
    {
      pageNo = 1,
      perPage = 10,
      search = "",
      difficultyLevel = "",
    }: { pageNo?: number; perPage?: number; search?: string; difficultyLevel?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetchQuestionsSetAPI(pageNo, perPage, search, difficultyLevel);
      console.log(response);

      return {
        results: response?.data?.results || [],
        totalRecord: response?.data?.totalRecord || 0,
      };
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "Error fetching questions"
      );
    }
  }
);

export const fetchQuestionsByTags = createAsyncThunk(
  "questions/fetchQuestionsByTags",
  async (
    {
      pageNo = 1,
      perPage = 10,
      search = "",
      reset = false,
    }: { pageNo?: number; perPage?: number; search?: string; reset?: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetchQuestionsByTagsAPI(pageNo, perPage, search);
      return { data: response?.data?.results || [], reset };
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "Error fetching questions"
      );
    }
  }
);

const questionSlice = createSlice({
  name: "questions",
  initialState: {
    questions: [] as any[],
    totalRecords: 0,
    questionTags: [] as any[],
    questionSet: [] as any[],
    loading: false,
    error: null as string | null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchQuestions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = action.payload.results;
        state.totalRecords = action.payload.totalRecord;

        console.log("Questions:", action.payload);
      })
      .addCase(fetchQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(fetchQuestionsSet.pending, (state) => {
        console.log("pendimg")

        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuestionsSet.fulfilled, (state, action) => {
        console.log("fullfil")
        state.loading = false;

        state.questionSet = action.payload.results;
        state.totalRecords = action.payload.totalRecord;

        console.log("questionSet:", state.questionSet);
        console.log(state.questionSet);

      })
      .addCase(fetchQuestionsSet.rejected, (state, action) => {
        console.log("rejeedte")

        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(fetchQuestionsByTags.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuestionsByTags.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.reset) {
          state.questionTags = action.payload.data;
        } else {
          state.questionTags = [
            ...state.questionTags,
            ...action.payload.data,
          ];
        }
      })
      .addCase(fetchQuestionsByTags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default questionSlice.reducer;